//React imports
import React from 'react';

//Imports the components
import FooterComponent from '../components/home/FooterComponent.js';
import NavBarComponent from '../components/navBar/NavBarComponent.js';
import TermsComponent from '../components/TermsComponent.js'

function termspage() {
    return (
        <div>
            <div className="updated-page-wrapper">

                <NavBarComponent/>
                <TermsComponent />
                <FooterComponent/>

            </div>
        </div>

    );
}

export default termspage;
